/**
 * 차트 공통 토큰 — 팔레트·시각 상수·라이브러리 툴팁 스타일.
 *
 * 색은 전부 tokens.css 의 `--chart-*` 를 가리킨다(hex 금지). SVG 라 var() 를 그대로 쓴다.
 */

/** 시리즈 순환 팔레트 — 1=관급 파랑, 2=사급 그린으로 도메인색과 정렬 */
export const CHART_PALETTE: readonly string[] = [
  "var(--chart-1)",
  "var(--chart-2)",
  "var(--chart-3)",
  "var(--chart-4)",
  "var(--chart-5)",
  "var(--chart-6)",
  "var(--chart-7)",
  "var(--chart-8)",
  "var(--chart-9)",
  "var(--chart-10)",
];

/** i 번째 시리즈 색 (순환) */
export function paletteColor(i: number): string {
  return CHART_PALETTE[((i % CHART_PALETTE.length) + CHART_PALETTE.length) % CHART_PALETTE.length];
}

/** 도메인 의미가 있는 색 — 관급/사급/중립(합계선 등) */
export const CHART_SEMANTIC = {
  gov: "var(--chart-gov)",
  cust: "var(--chart-cust)",
  neutral: "var(--chart-neutral)",
} as const;

/** SVG 차트 시각 상수 — 축 글자·선 굵기·포인트 반지름 등 (모든 화면 공통) */
export const CHART_TOKENS = {
  /** 캔버스/SVG 속성이라 px 숫자 유지 (DESIGN.md 예외) */
  axisFontSize: 10.5,
  legendFontSize: 12,
  gridColor: "var(--chart-grid)",
  gridOpacity: 0.35,
  baselineOpacity: 0.5,
  axisLabelColor: "var(--c-text-muted)",
  lineStrokeWidth: 1.75,
  lineStrokeWidthEmphasis: 2.25,
  lineBorderWidth: 1.5,
  pointRadius: 3,
  pointRadiusHover: 4.5,
  barRadius: 2,
  hoverCrosshairOpacity: 0.4,
  /** X 라벨 하나가 차지해야 하는 최소 폭(px) — 이보다 좁으면 라벨을 건너뛴다 */
  minXLabelPx: 28,
} as const;
